module.exports = __webpack_public_path__ + "img/instrument-bonuses.f6c445c9.png";